module.exports = __webpack_public_path__ + "img/f26.12bc1ee8.png";